<template>
  <CommonExpansionPanel :currentPanel="0">
    <template v-slot:title-panel>
      Validación de contacto telefónico de emisiones Alianzas</template
    >
    <v-expansion-panel-content>
      <ReporteOnboardFilters
        @searchUpdated="getEmisionesPhoneValidations"
        :currentFilters="filtros"
        :loading="loading"
        :currentAlianza="alianza"
        @alianzaUpdated="alianza = $event"
      >
      </ReporteOnboardFilters>
      <hr />
      <ReporteOnboardTable
        :loading="loading"
        :emisiones="emisiones"
        :totalItems="totalItems"
        :page="page"
        :itemsPerPage="itemsPerPage"
        @pageChanged="onPageChanged"
        @itemsPerPageChanged="onItemsPerPageChanged"
      />
    </v-expansion-panel-content>
    <v-row class="py-4 px-6 align-center justify-space-between">
      <v-col cols="12" md="6">
        <h3 class="mb-0" style="color: #42352E;">
          Registros a validar: <strong>{{ totalItems }}</strong>
        </h3>
      </v-col>
      <v-col cols="12" md="6" class="text-end">
        <v-btn
          dark
          color="#00a7e4"
          rounded
          class="mr-2"
          min-width="120"
          :loading="loading"
          @click="validateEmisiones"
        >
          Validar
        </v-btn>
      </v-col>
    </v-row>
  </CommonExpansionPanel>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import {
  getEmisionesPhoneValidation,
  getEmisionesPhoneValidationIds,
  postValidatePhone,
} from "@/services/emision/emision.service";
import ReporteOnboardFilters from "./ReportePhoneValidationFilters.vue";
import ReporteOnboardTable from "./ReportePhoneValidationTable.vue";

export default {
  components: {
    CommonExpansionPanel,
    ReporteOnboardFilters,
    ReporteOnboardTable,
  },

  data() {
    return {
      switch_data: 1,
      emisiones: [],
      emisionesIds: [],
      filtros: {},
      loading: false,
      page: 1,
      totalItems: 0,
      itemsPerPage: 10,
      alianza: {},
    };
  },
  props: {
    contactData: Object,
    correosDataFormat: Object,
    routesContactData: Object,
  },
  methods: {
    async getEmisionesPhoneValidations(filtros = this.filtros) {
      this.loading = true;
      this.filtros = filtros;
      try {
        const offset = (this.page - 1) * this.itemsPerPage;
        const response = await getEmisionesPhoneValidation(
          filtros,
          this.itemsPerPage,
          offset
        );
        if (response.data && response.data.length) {
          this.emisiones = response.data.map((emision) => {
            const result = {
              ...emision,
            };
            return result;
          });

          this.totalItems = response.count;
          this.emisionesIds = await getEmisionesPhoneValidationIds(filtros);
        } else {
          this.emisiones = [];
          this.totalItems = 0;
        }
      } catch (error) {
        console.log("Error", error);
      } finally {
        this.loading = false;
      }
    },

    onPageChanged(newPage) {
      this.page = newPage;
      this.getEmisionesPhoneValidations();
    },
    onItemsPerPageChanged(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.page = 1;
      this.getEmisionesPhoneValidations();
    },

    async validateEmisiones() {
      this.loading = true;
      try {
        const limiteBloque = this.alianza?.envios_onboarding ?? 0;
        let bloqueIds = [];

        if (this.emisionesIds.length > limiteBloque && limiteBloque != 0) {
          bloqueIds = this.emisionesIds.slice(0, limiteBloque);
          this.$toast.info(
            `Se enviarán los primeros ${limiteBloque} registros`
          );
        } else {
          bloqueIds = this.emisionesIds;
        }

        if (this.totalItems === 0) {
          this.$toast.warning("No hay emisiones para validar");
          return;
        }

        try {
          await postValidatePhone(bloqueIds);
          this.$toast.success("Emisiones validadas con éxito");
          this.emisiones = [];
          this.totalItems = 0;
        } catch (error) {
          console.error("Error: ", error);
          this.$toast.error("Algo falló al validar las emisiones");
        }
      } finally {
        this.emisiones = [];
        this.loading = false;
      }
    },
  },
  mounted() {},
};
</script>
